import React from 'react';
import { Link } from 'react-router-dom';
import MiniContactForm from '../components/MiniContactForm';
import FAQ from '../components/FAQ';

const GILBERT_FAQ = [
  {
    question: 'What areas of Gilbert do you serve?',
    answer: 'We serve all neighborhoods and business districts throughout Gilbert, including Agritopia, Power Ranch, Val Vista Lakes, The Islands, and more. If you\'re in Gilbert, we can help!'
  },
  {
    question: 'Do you offer both residential and commercial power washing in Gilbert?',
    answer: 'Yes! We provide professional power washing for homes, businesses, HOAs, apartment complexes, and more throughout Gilbert.'
  },
  {
    question: 'How soon can I schedule service in Gilbert?',
    answer: 'We offer flexible scheduling and can often provide same-week service in Gilbert. Contact us for our next available appointment!'
  }
];

const GilbertPowerWashing = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <section className="w-full h-48 sm:h-64 md:h-80 lg:h-96 mb-8 rounded-lg overflow-hidden bg-gray-200 flex items-center justify-center" aria-label="Gilbert Power Washing Banner">
      <picture>
        <source srcSet="/gilbert_hero.avif" type="image/avif" />
        <source srcSet="/gilbert_hero.webp" type="image/webp" />
      <img 
        src="/gilbert_hero.jpeg" 
        alt="Gilbert power washing in action" 
        className="w-full h-full object-cover object-center" 
          width="1600"
          height="400"
      />
      </picture>
    </section>
    <div className="max-w-3xl mx-auto">
      <h1 className="text-4xl font-bold text-[#4a3f35] mb-6">Gilbert Power Washing</h1>
      <h2 className="text-2xl font-semibold text-[#b87c4c] mb-4">Professional Power Washing Services in Gilbert</h2>
      <p className="mb-6 text-gray-700">We provide expert power washing for homes, businesses, and public spaces throughout Gilbert. Our team uses advanced equipment and eco-friendly solutions to keep your property looking its best.</p>
      <h3 className="text-xl font-semibold text-[#4a3f35] mb-2">Why Choose Us?</h3>
      <ul className="list-disc pl-6 mb-6 text-gray-700">
        <li>Experienced, local technicians</li>
        <li>Eco-friendly cleaning solutions</li>
        <li>Flexible scheduling for Gilbert residents and businesses</li>
        <li>100% satisfaction guarantee</li>
      </ul>
      <div className="bg-[#f8f7f3] border-l-4 border-[#b87c4c] p-6 rounded-lg shadow mb-8">
        <h3 className="text-lg font-bold text-[#b87c4c] mb-2">Get a Free Quote for Gilbert Power Washing!</h3>
        <p className="mb-4 text-gray-700">Contact us today for a special offer on our Gilbert power washing services.</p>
        <Link 
          to="/contact" 
          className="inline-block px-6 py-2 bg-[#b87c4c] text-white font-medium rounded-lg shadow hover:bg-[#a06940] transition-colors duration-200"
        >
          Get a Free Quote
        </Link>
      </div>
    </div>
    <div className="max-w-2xl mx-auto mt-12 mb-12">
      <MiniContactForm />
    </div>
    <FAQ items={GILBERT_FAQ} title="Frequently Asked Questions About Gilbert Power Washing" />
  </div>
);

export default GilbertPowerWashing; 